import React, { useState } from "react";
import { Box, Button, Grid, Modal, TextField, Typography } from "@mui/material";

const functions = [
  "min", "max", "pow", "sqrt", "avg", "ln2", "ln10", "log2E", "log10E", "sqrt1/2", "sqrt2",
  "floor", "round", "abs", "random", "ceil", "exp", "sin", "cos", "asin", "acos", "tan", "atan",
  "secToMin", "secToHours", "secToDays", "secToWeeks", "secToMonths",
  "minToHours", "minToDays", "minToWeeks", "minToMonths",
  "hoursToDays", "hoursToWeeks", "hoursToMonths",
  "daysToWeeks", "daysToMonths"
];

const FunctionSelectorModal = ({ open, handleClose, onSelect }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filtered = functions.filter((fn) =>
    fn.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        width={{ xs: "320px", md: "700px" }}
        bgcolor="background.paper"
        p={2}
        m="auto"
        mt="5vh"
        borderRadius={1}
        boxShadow={4}
      >
        <Typography variant="h6" mb={2}>یک تابع را انتخاب کنید</Typography>
        <TextField
          fullWidth
          placeholder="جستجو..."
          variant="outlined"
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Grid container spacing={1} sx={{ maxHeight: 400, overflowY: "auto" }}>
          {filtered.map((fn) => (
            <Grid item xs={6} md={4} key={fn}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => { onSelect(fn); handleClose(); }}
              >
                {fn}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Modal>
  );
};

export default FunctionSelectorModal;
